import { useQuery } from "@tanstack/react-query";
import { getPaalaeg } from "@/api/paalaeg";
import type { PaalaegDetailModel } from "@/interfaces/paalaeg";
import { PAALAEGS_QUERY_KEY } from "./usePaalaegs";

export const createPaalaegQueryKey = (paalaegId: string) =>
  [...PAALAEGS_QUERY_KEY, paalaegId] as const;

export const usePaalaeg = (paalaegId: string) =>
  useQuery<PaalaegDetailModel>({
    enabled: paalaegId.length > 0,
    queryKey: createPaalaegQueryKey(paalaegId),
    queryFn: () => getPaalaeg(paalaegId),
    staleTime: 5 * 60 * 1000,
  });
